<template>
    <alert-outline add-class="pa-2">
        <span class="text-caption">
            {{ $t('The_assigned_node_info_can_be_used_as_the_following_placeholders') }}
        </span>
        <tooltip-label :message="$t('Please_enclose_placeholder_in_[_]')" top />
        <ul class="text-caption">
            <li>
                {{ $t('IP_Address_Host') + ' ( ' + $t('NODE_ADDRESS') + ' ) ' }}
            </li>
            <li>
                {{ $t('Port_Number') + ' ( ' + $t('NODE_PORT') + ' ) ' }}
            </li>
            <li>
                {{ $t('Worker_Account_ID') + ' ( ' + $t('ACCOUNT_NAME') + ' ) ' }}
            </li>
            <li>
                {{ $t('Worker_Account_Password') + ' ( ' + $t('ACCOUNT_PASSWORD') + ' ) ' }}
            </li>
        </ul>
    </alert-outline>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AlertOutline } from './';
import TooltipLabel from './TooltipLabel.vue';

@Component({
    name: 'AutoLoginApplicationParamsDescription',
    components: {
        AlertOutline,
        TooltipLabel,
    },
})
export default class AutoLoginApplicationParamsDescription extends Vue {}
</script>
